<template>
  <v-card
    class="proposal-card d-flex flex-column"
    rounded="sm"
    flat
    :style="{
      color: color,
      backgroundColor: backgroundColor
    }"
    :href="link"
    @click.prevent="handleLink"
  >
    <v-img
      :src="src"
      :title="'logo' + proposal.descr"
      :alt="'Immagine' + proposal.descr"
    />
    <v-card-text
      class="text-h6 text-center font-weight-bold text-none"
      v-if="showContent"
      v-html="proposal.descr"
      :style="{
        color: color
      }"
    ></v-card-text>
    <v-card-text
      class="text-subtitle-1 text-center text-none pa-0"
      v-if="showContent && proposal.content"
      v-html="proposal.content"
    ></v-card-text>
    <v-spacer />
  </v-card>
</template>
<style scoped lang="scss">
.pre-slide-text {
  width: initial;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
}

.content {
  font-size: 12px;
  line-height: 18px;
}
</style>
<script>
import banner from "~/mixins/banner";
import get from "lodash/get";

export default {
  name: "ProposalCard",
  props: ["proposal", "showContent"],
  mixins: [banner],
  computed: {
    color() {
      return get(this.proposal, "metaData.category_proposal_type.COLOR");
    },
    backgroundColor() {
      return get(this.proposal, "metaData.category_proposal_type.BG_COLOR");
    },
    src() {
      let prop =
        "metaData.category_proposal_type." +
        (this.$vuetify.breakpoint.xs ? "IMAGE_MOBILE" : "IMAGE_DESKTOP");
      return get(this.proposal, prop, this.proposal.img);
    }
  }
};
</script>
